import { CacheDescriptor } from '../store/schema/CacheDescriptor';
import { ItemCache } from '../store/schema/ItemCache';
import { ItemCacheLockId } from 'owa-items-cache';

export function checkContainsDescriptorForLock<T, U extends CacheDescriptor>(
    store: ItemCache<T, U>,
    lockId: ItemCacheLockId,
    descriptor: U,
    containsDescriptor: (descriptor1: U, descriptor2: U) => boolean
): boolean {
    const lockedDescriptorIds = store.locks.get(lockId);
    let descriptors = lockedDescriptorIds?.map(descriptorId => store.descriptors.get(descriptorId));
    return descriptors ? descriptors.some(d => d && containsDescriptor(d, descriptor)) : false;
}
